import { CustomerContact } from 'src/app/api';
import { ProfileContactsService } from '../../../../app/services/profile/profile-contacts.service';
import { BaseModalController } from '../../../base-modal.controller';

export class RemoverContatoController extends BaseModalController {
  /*@ngInject*/ constructor(
    $uibModalInstance,
    private $profileContacts: ProfileContactsService,
    public contato: CustomerContact,
  ) {
    super($uibModalInstance);
  }

  public remover() {
    this.$profileContacts.deleteContact(this.contato).subscribe(
      () => this.$uibModalInstance.close({}),
    );
  }
}
